<template>
  <div class="back-btn-ui">
    <VBtn :to="to" class="go-back" flat @click="emitClick">
      <span class="back-btn-ui__icon">
        <ChevronLeftIcon />
      </span>
      <span class="back-btn-ui__label">{{ label }}</span>
    </VBtn>
  </div>
</template>

<script setup lang="ts">
  // Components
  import VBtn from '~/misc/v-btn';
  import ChevronLeftIcon from '~/misc/icons/chevron-left/ChevronLeftIcon.vue';

  defineProps({
    to: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: 'Back',
    },
  });

  const emit = defineEmits<{
    (e: 'click'): void;
  }>();

  const emitClick = () => emit('click');
</script>
